module.exports = __webpack_public_path__ + "img/top-category-sports.5fb8c8d9.jpg";